import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base';

export type BurnInJobResponse = {
  job_id: number;
  status: 'queued' | 'processing' | 'ready' | 'failed';
  download_url?: string | null;
  error?: string | null;
};

type StartBurnInParams = {
  sessionId: string;
  documentId: string;
};

async function startBurnInExport({
  sessionId,
  documentId
}: StartBurnInParams): Promise<BurnInJobResponse> {
  const { data } = await Axios.post<BurnInJobResponse>(
    GET_URL(sessionId, documentId).documentBurnIn
  );
  return data;
}

export function useStartBurnInExport() {
  return useMutation<
    BurnInJobResponse,
    AxiosError<BaseError>,
    StartBurnInParams
  >(startBurnInExport);
}
